import store from '@/store'
import axios from 'axios'
// import router from '@/router/'

export default {
  namespaced: true,
  state: {
    acarreo: [],
    estadosAcarreo: [],
    acarreoReports: []
  },
  mutations: {
    set_accion_Acarreo (state, acarreo) {
      state.acarreo = acarreo
    },
    set_accion_acarreoReports (state, acarreoReports) {
      state.acarreoReports = acarreoReports
    },
    set_accion_estados (state, estadosAcarreo) {
      state.estadosAcarreo = estadosAcarreo
    }
  },
  actions: {
    async getAcarreo ({ commit, dispatch, state }, data) {
      try {
        const response = await axios({
          method: 'get',
          url: `${store.state.host}/api/vps/acarreo`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: data
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api getaAcarreo')
          // console.log(response.data)
          commit('set_accion_Acarreo', response.data)
          return true
        } else {
          console.log('por else getaAcarreo')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch getaAcarreo')
        // router.push({ path: '/' })
        return false
      }
    },
    async getAcarreoFilter ({ commit, dispatch, state }, data) {
      try {
        const response = await axios({
          method: 'post',
          url: `${store.state.host}/api/vps/acarreo/filter?page=${data.page}&size=${data.size}`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: data
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api getAcarreoFilter')
          // console.log(response.data)
          commit('set_accion_Acarreo', response.data)
          return true
        } else {
          console.log('por else getAcarreoFilter')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch getAcarreoFilter')
        // router.push({ path: '/' })
        return false
      }
    },
    async getacarreoReports ({ commit, dispatch, state }, data) {
      try {
        const response = await axios({
          method: 'post',
          url: `${store.state.host}/api/vps/acarreo/report`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: data
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api getacarreoReports')
          // console.log(response.data)
          commit('set_accion_acarreoReports', response.data)
          return true
        } else {
          console.log('por else getacarreoReports')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch getacarreoReports')
        // router.push({ path: '/' })
        return false
      }
    },
    async updateEstadoAcarreo ({ commit, dispatch, state }, data) {
      try {
        const response = await axios({
          method: 'put',
          url: `${store.state.host}/api/vps/acarreo/updateEstado?estado=${data.estado}&id_acarreo=${data.id_acarreo}`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: data
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api updateEstadoAcarreo')
          // console.log(response)
          return response
        } else {
          console.log('por else updateEstadoAcarreo')
          return response
        }
      } catch (err) {
        // console.error(err)
        console.log('por catch updateEstadoAcarreo')
        // router.push({ path: '/' })
        // false y no el error: un Error es truthy y quien llama no podria
        // distinguir un guardado exitoso de uno fallido.
        return false
      }
    },
    async updateAcarreo ({ commit, dispatch, state }, data) {
      try {
        const response = await axios({
          method: 'put',
          url: `${store.state.host}/api/vps/acarreo/update`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: data
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api updateAcarreo')
          // console.log(response)
          return response
        } else {
          console.log('por else updateAcarreo')
          return response
        }
      } catch (err) {
        // console.error(err)
        console.log('por catch updateAcarreo')
        // router.push({ path: '/' })
        // Si el servidor respondio (400 con el detalle de que campo fallo),
        // devolvemos esa respuesta para que el componente pueda mostrarlo.
        // Si fue un fallo de red no hay respuesta: false, nunca el Error,
        // porque un Error es truthy y se confundiria con un exito.
        return err.response || false
      }
    },
    async deleteAcarreo ({ commit, dispatch, state }, idAcarreo) {
      try {
        const response = await axios({
          method: 'delete',
          url: `${store.state.host}/api/vps/acarreo?id_acarreo=${idAcarreo}`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          }
        })
        if (response.status === 200) {
          console.log('success stuff api deleteAcarreo')
          return response
        } else {
          console.log('por else deleteAcarreo')
          return response
        }
      } catch (err) {
        console.log('por catch deleteAcarreo')
        return err
      }
    },
    async getEstadosAcarreo ({ commit, dispatch, state }) {
      try {
        const response = await axios({
          method: 'get',
          url: `${store.state.host}/api/vps/acarreo/estados`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          }
        })
        if (response.status === 200) {
          console.log('success stuff api getestadosAcarreo')
          commit('set_accion_estados', response.data)
          return response
        } else {
          console.log('por else getestadosAcarreo')
          return response
        }
      } catch (err) {
        console.log('por catch getestadosAcarreo')
        return err
      }
    }
  },
  getters: {
  }
}
